import { Refine, Authenticated } from "@refinedev/core";
import routerProvider, { NavigateToResource } from "@refinedev/react-router-v6";
import { dataProvider, liveProvider } from "@refinedev/supabase";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { supabase } from "@/lib/supabase";
import { authProvider } from "@/providers/authProvider";
import { resources } from "@/resources";
import { Layout } from "@/components/layout/Layout";
import { HomePage } from "@/pages/HomePage";
import { LoginPage } from "@/pages/auth/LoginPage";
import { RecoveryPage } from "@/pages/auth/RecoveryPage";
import { TiendasPage } from "@/pages/admin/TiendasPage";
import { TiendaForm } from "@/pages/admin/TiendaForm";
import { FinancierasPage } from "@/pages/admin/FinancierasPage";
import { FinancieraForm } from "@/pages/admin/FinancieraForm";
import { VendedoresPage, VendedorForm } from "@/pages/admin/VendedoresPage";
import { ProductosPage, ProductoForm } from "@/pages/admin/ProductosPage";
import { UsuariosPage } from "@/pages/admin/UsuariosPage";
import { ClientesPage } from "@/pages/clientes/ClientesPage";
import { VentasListPage } from "@/pages/ventas/VentasListPage";
import { NuevaVentaPage } from "@/pages/ventas/NuevaVentaPage";
import { VentaDetallePage } from "@/pages/ventas/VentaDetallePage";
import { CortesListPage } from "@/pages/cortes/CortesListPage";
import { CorteDetallePage } from "@/pages/cortes/CorteDetallePage";
import { CerrarCortePage } from "@/pages/cortes/CerrarCortePage";
import { KanbanPage } from "@/pages/admin/KanbanPage";
import { LiquidarPeriodoPage } from "@/pages/admin/LiquidarPeriodoPage";
import { NuevoPagoPage } from "@/pages/pagos/NuevoPagoPage";
import { PagosListPage } from "@/pages/pagos/PagosListPage";
import { AnularVentaPage } from "@/pages/anulaciones/AnularVentaPage";
import { AnulacionesListPage } from "@/pages/anulaciones/AnulacionesListPage";
import { ConfigPage } from "@/pages/config/ConfigPage";

export function App() {
  return (
    <BrowserRouter>
      <Refine
        dataProvider={dataProvider(supabase)}
        liveProvider={liveProvider(supabase)}
        authProvider={authProvider}
        routerProvider={routerProvider}
        resources={resources}
        options={{
          syncWithLocation: true,
          warnWhenUnsavedChanges: true,
          useNewQueryKeys: true,
        }}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/recovery" element={<RecoveryPage />} />

          <Route
            element={
              <Authenticated key="protected" fallback={<Navigate to="/login" />}>
                <Layout>
                  <Outlet />
                </Layout>
              </Authenticated>
            }
          >
            <Route index element={<HomePage />} />

            {/* Ventas */}
            <Route path="/ventas" element={<VentasListPage />} />
            <Route path="/ventas/nueva" element={<NuevaVentaPage />} />
            <Route path="/ventas/:id" element={<VentaDetallePage />} />
            <Route path="/ventas/:id/anular" element={<AnularVentaPage />} />

            {/* Cuentas de cobro / cortes */}
            <Route path="/cuentas-cobro" element={<CortesListPage />} />
            <Route path="/cuentas-cobro/:id" element={<CorteDetallePage />} />
            <Route path="/cuentas-cobro/:id/cerrar" element={<CerrarCortePage />} />

            {/* Pagos */}
            <Route path="/pagos" element={<PagosListPage />} />
            <Route path="/pagos/nuevo" element={<NuevoPagoPage />} />

            {/* Anulaciones */}
            <Route path="/anulaciones" element={<AnulacionesListPage />} />
            {/* Para crear una anulación, hay que partir de una venta existente. */}
            <Route path="/anulaciones/nueva" element={<Navigate to="/ventas" replace />} />

            {/* Clientes */}
            <Route path="/clientes" element={<ClientesPage />} />

            {/* Admin */}
            <Route path="/admin/kanban" element={<KanbanPage />} />
            <Route path="/admin/periodos/:id/liquidar" element={<LiquidarPeriodoPage />} />
            <Route path="/admin/tiendas" element={<TiendasPage />} />
            <Route path="/admin/tiendas/nueva" element={<TiendaForm />} />
            <Route path="/admin/tiendas/:id/editar" element={<TiendaForm />} />
            <Route path="/admin/financieras" element={<FinancierasPage />} />
            <Route path="/admin/financieras/nueva" element={<FinancieraForm />} />
            <Route path="/admin/financieras/:id/editar" element={<FinancieraForm />} />
            <Route path="/admin/vendedores" element={<VendedoresPage />} />
            <Route path="/admin/vendedores/nuevo" element={<VendedorForm />} />
            <Route path="/admin/vendedores/:id/editar" element={<VendedorForm />} />
            <Route path="/admin/productos" element={<ProductosPage />} />
            <Route path="/admin/productos/nuevo" element={<ProductoForm />} />
            <Route path="/admin/productos/:id/editar" element={<ProductoForm />} />
            <Route path="/admin/usuarios" element={<UsuariosPage />} />

            <Route path="/config" element={<ConfigPage />} />

            <Route path="*" element={<NavigateToResource />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </Refine>
    </BrowserRouter>
  );
}
